import Icon from '../components/Icon.vue'

Icon.register({"mobile":{"width":320,"height":512,"paths":[{"d":"M272 0H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H272C298.5 512 320 490.5 320 464V48C320 21.5 298.5 0 272 0zM160 480C142.3 480 128 465.7 128 448S142.3 416 160 416 192 430.3 192 448 177.7 480 160 480z"}]}})



// WEBPACK FOOTER //
// ./node_modules/vue-awesome/icons/mobile.js